import { mainClient } from '~/network';

const state = {
    subscribeResult: null,
    subscribeIsLoading: false,
    subscribeError: null,

    unSubscribeResult: null,
    unSubscribeIsLoading: false,
    unSubscribeError: null,
};

const getters = {};

const mutations = {};

const actions = {
    async subscribe({ state }, { onSuccess = null, onError = null, ...payload }) {
        if (state.subscribeIsLoading) {
            return;
        }

        state.subscribeIsLoading = true;

        const { error } = await mainClient.common.subscribe(payload);

        if (error) {
            state.subscribeError = error;
            state.subscribeResult = null;
            if (onError) {
                onError(state.subscribeError);
            }
        } else {
            state.subscribeError = null;
            state.subscribeResult = 'success';
            if (onSuccess) {
                onSuccess(state.subscribeResult);
            }
        }

        state.subscribeIsLoading = false;
    },
    async unsubscribe({ state }, { onSuccess = null, onError = null, ...payload }) {
        if (state.unSubscribeIsLoading) {
            return;
        }

        state.unSubscribeIsLoading = true;

        const { error } = await mainClient.common.unsubscribe(payload);

        if (error) {
            state.unSubscribeError = error;
            state.unSubscribeResult = null;
            if (onError) {
                onError(state.unSubscribeError);
            }
        } else {
            state.unSubscribeError = null;
            state.unSubscribeResult = 'success';
            if (onSuccess) {
                onSuccess(state.unSubscribeResult);
            }
        }

        state.unSubscribeIsLoading = false;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
